export type NavLinkPosition = 'left' | 'right'
